<template>
  <MapPopup
      v-if="object"
      icon="icon-object"
      :title="object.name"
      :data="mainData"
      :secondary-data="secondaryData"
      :actions="object.config?.actions"
      :progress="object.loading"
      :lat="object.lat"
      :lng="object.lng"
      show-tabs
      @close="emit('close')"
  >
    <div class="map-popup__row">
      <span class="label">
        {{ $t('front.address') }}
      </span>

      <span class="value">
        <Address :lat="object.lat" :lng="object.lng" />
      </span>
    </div>
  </MapPopup>
</template>
<script setup>
import MapPopup from "@/js/Components/MapPopup/Popup.vue";
import {computed, onBeforeUnmount} from "vue";
import {useStore} from "vuex";
import {useI18n} from "vue-i18n";
import { googleMapUrl } from '@/js/helpers.js';
import Address from "@/js/Elements/Address.vue";
import axios from "axios";
import {OBJECT_ICON_TYPE_ARROW, OBJECT_ICON_TYPE_ROTATING} from "@/js/constants.js";

const store = useStore();
const props = defineProps({
  id: Number,
});
const { t } = useI18n();
const emit = defineEmits(['close']);
const object = computed(() => store.getters['object/find'](props.id));
const units = computed(() => store.getters['settings/units']);
const iso = computed(() => store.getters['app/iso']);
const sharingHash = computed(() => store.getters['auth/sharingHash']);
const angle = computed(() => {
  if ([OBJECT_ICON_TYPE_ARROW, OBJECT_ICON_TYPE_ROTATING].indexOf(object.value?.icon?.type) === -1) {
    return 0;
  }
  return object.value.course;
});

// if (!sharingHash.value && object.value?.id) {
//   axios.get('/payload/map/object-actions', {
//     params: { device_id: object.value.id}
//   }).then((response) => {
//     store.commit('object/updateInList', response.data.data[0]);
//   });
// }

const mainData = computed(() => {
  const data = [
    { title: t('front.time'), value: object.value.time },
    { title: t('front.stop_duration'), value: object.value.stop_duration },
  ];

  if (object.value?.sensors) {
    object.value.sensors.forEach(s => data.push(s));
  }

  if (object.value?.expiration_date) {
    data.push({
      title: t('front.expiration_date'),
      value: object.value.expiration_date
    })
  }
  return data;
});

const secondaryData = computed(() => {
  const data = [
    {
      title: t('front.position'),
      value: `<a href="${googleMapUrl(object.value.lat, object.value.lng)}" target="_blank">${object.value.lat}&deg;,${object.value.lng}&deg;</a>`,
    }, {
      title: t('front.altitude'),
      value: object.value.altitude || '-'
    }, {
      title: t('front.angle'),
      value: angle.value ? `${angle.value}&deg;` : '-',
    }, {
      title: t('front.driver'),
      value: object.value?.driver?.name || '-'
    }, {
      title: t('front.model'),
      value: object.value?.model || '-'
    }, {
      title: t('front.plate'),
      value: object.value?.plate || '-'
    }, {
      title: t('front.protocol'),
      value: object.value?.protocol || '-'
    },
  ];

  if (object.value.services) {
    object.value.services.forEach(s => data.push(s));
  }

  return data;
});
</script>
